export default function Error({ error }) {
  return <p style={{ marginBottom: ".5rem", color: "red" }}>{error}</p>;
}
